export default __webpack_public_path__ + "static/media/schedualing_icon_red.dabf7c47.svg";